<template>

    <div class="checkinsHolder">
        <div class="row" v-if="!audienceTypes">
            loading
        </div>

        <div class="row" v-if="reservation.billing && audienceTypes">

            <div class="col-sm-5 bg-lighter border-right-light py-3">

                <div class="d-flex justify-content-between font-weight-600 mb-2">
                    <span>Total Pax:</span><span>{{totalPax}}</span>
                </div>


                <template v-if="reservation.bookingGenderPrices.length > 0">

                    <div v-if="personPrice.audienceType" class="d-flex flex-column justify-content-between fs-small align-items-center my-1" v-for="personPrice,index in reservation.bookingGenderPrices">
                        <div class="w-100" v-tooltip="genderPriceObj(personPrice).description">{{genderPriceObj(personPrice).name}}:</div>
                        <div class="w-100 d-flex justify-content-between align-items-center">
                            <span v-if="audienceTypes" class="">
                                <div v-if="genderPriceObj(personPrice).description">{{genderPriceObj(personPrice).description}}:</div>
                                <div v-if="showPrice" class="fs-smallest dark">({{formatPrice(showTicketPrice(personPrice))}}€)</div>
                            </span>

                            <span class="font-weight-600" v-if="!editingPax">
                                {{personPrice.quantityToBook}}
                            </span>



                        </div>
                        <div class="paxQtdEditor font-weight-600 w-100 mt-1 text-center" v-if="editingPax">
                            <span class="bg-lightest border-medium radius-normal p-1 pointer" @click="changePax('subtract', personPrice)"><i class="m-0 ico ico-minus fs-smallest"></i></span>
                            <input :disabled="disabled" readonly type="number" style="width: 28px;" class="px-0 py-1 text-center" v-model.number="personPrice.quantityToBook" @input.lazy="paxManuallyChanged(personPrice)"></input>
                            <span class="bg-lightest border-medium radius-normal p-1 pointer" @click="changePax('add', personPrice)"><i class="m-0 ico ico-add fs-smallest"></i></span>
                        </div>
                    </div>

                </template>

                <div class="mt-2" v-if="reservation.bookingGenderPrices.length > 0 && !isPerOrderWithoutParticipants" :class="{'opacity-50': isReservationReadOnly}">
                    <button v-if="showEditPax" :disabled="disabled" class="btn tertiary w-100" @click="toggleEditPax">{{editingPax? 'Apply' : 'Edit'}}</button>
                </div>

            </div>

            <div class="col-sm-7 p-2" :class="{'opacity-50': !checkinAllowed}">

                <div class="d-flex justify-content-between">
                    <div class="dark pt-2">
                        Check-In
                    </div>

                    <div class="d-flex">
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="decrementCheckin"> - </button>
                        <input :disabled="disabled" type="number" class="text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2" style="width: 2rem;" value="0" v-model="reservation.paxCheckedIn" @blur="checkinBlur"></input>
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="incrementCheckin"> + </button>
                    </div>
                </div>

                <div class="d-flex justify-content-between mt-2">
                    <div class="dark pt-2">
                        No-Show
                    </div>

                    <div class="d-flex">
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="decrementNoShow"> - </button>
                        <input :disabled="disabled" type="number" class="text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2" style="width: 2rem;" value="0" v-model="reservation.paxNoShow" @blur="noShowBlur"></input>
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="incrementNoShow"> + </button>
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-3">
                    <span v-if="totalPax == 0" class="bold dark" @click="checkAllIn">No Pax selected</span>
                    <button :disabled="disabled" v-else-if="!allChecked" class="btn tertiary" @click="checkAllIn">Check-in All</button>
                    <button :disabled="disabled" v-else-if="allChecked" class="btn tertiary" :class="checkinAllButton" @click="checkAllIn">All checked <i class="ico ico-check mr-0 ml-2"></i></button>
                </div>

                <div class="col-sm-12 py-3 text-center" v-if="!checkinAllowed">
                    <span v-if="isReservationReadOnly">Booking read only</span>
                    <span v-else-if="totalDue > 0">Booking not paid</span>
                </div>

            </div>

        </div>

        <div v-else class="dark text-center m-3">
            <div class="fs-large darker">Loading</div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'

import {mapActions, mapGetters} from 'vuex'
import {eventHub} from '@/main'

export default {
    data: function() {
        return {
            editingPax: false,
            showDetailedCheckin: false
        }
    },
    props:{
        reservation:{
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    asyncComputed: {
        async audienceTypes() {
            try {
                let response = await axios.get('/api/settings/GetAudienceTypeList');

                if (response && response.status === 200 && response.data && response.data.length > 0) {

                    return response.data;
                }
            }
            catch (error) {
                this.$toasted.error(error);
            }
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getShowInvoiceOption'
        ]),
        isPerOrderWithParticipants: function () {
            return this.reservation.bookingGenderPrices.length > 1 && // have more than 1 gender price
                    this.reservation.bookingGenderPrices[0].genderPriceType == 1 // item 0 is per order
        },
        isPerOrderWithoutParticipants: function () {
            return this.reservation.bookingGenderPrices.length == 1 && // have more than 1 gender price
                    this.reservation.bookingGenderPrices[0].genderPriceType == 1 // item 0 is per order
        },
        showPrice: function () {
            return !this.isPerOrderWithParticipants // show if is now per order with participants
        },
        showEditPax: function () {
            // return this.getShowInvoiceOption == false
            return true
        },
        allChecked: function() {
            return this.reservation.paxCheckedIn + this.reservation.paxNoShow == this.totalPax
        },
        totalDue: function(){
            // return this.getReservationCalculations.grandTotal - this.paid
            return Math.round((this.getReservationCalculations.grandTotal - this.paid) * 100) / 100
        },
        checkinAllowed: function() {
            return this.totalDue <= 0 && !this.isReservationReadOnly
        },
        checkinAllButton: function () {
            if(!this.reservation.updateFlags.checkins || this.reservation.updateFlags.checkins !== true){
                if(this.reservation.paxNoShow > 0){
                    return 'bg-color-4 lightest'
                } else {
                    return 'bg-color-3 lightest'
                }
            } else {
                return ''
            }
        }
    },
    mixins: [
        reservationsMixin,
    ],
    methods: {
        ...mapActions([
            'updateCheckinsNoShows',
            'updateExistingReservation',
            'setReservationCalculations',
        ]),
        incrementCheckin: function() {
            if(this.checkinAllowed ){
                if(this.reservation.paxCheckedIn < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                    this.reservation.paxCheckedIn++
                    this.checkinNoShowChanged()
                }
            }
        },
        decrementCheckin: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxCheckedIn > 0){
                    this.reservation.paxCheckedIn--
                    this.checkinNoShowChanged()
                }
            }
        },
        checkinBlur: function () {
            if(this.reservation.paxCheckedIn >= 0 && (this.reservation.paxCheckedIn <= this.totalPax && (parseInt(this.reservation.paxCheckedIn) + parseInt(this.reservation.paxNoShow)) <= this.totalPax)){
                //tweak to make the button "all checked in" update
                this.reservation.paxCheckedIn++
                this.reservation.paxCheckedIn--

                this.checkinNoShowChanged()
            } else {
                this.reservation.paxCheckedIn = 0
                this.$toasted.error('Invalid Check-in amount');
            }
        },
        incrementNoShow: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxNoShow < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                    this.reservation.paxNoShow++
                    this.checkinNoShowChanged()
                }
            }
        },
        decrementNoShow: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxNoShow > 0){
                    this.reservation.paxNoShow--
                    this.checkinNoShowChanged()
                }
            }
        },
        noShowBlur: function () {
            if(this.reservation.paxNoShow >= 0 && (this.reservation.paxNoShow <= this.totalPax && (parseInt(this.reservation.paxCheckedIn) + parseInt(this.reservation.paxNoShow)) <= this.totalPax)){
                //tweak to make the button "all checked in" update
                this.reservation.paxNoShow++
                this.reservation.paxNoShow--

                this.checkinNoShowChanged()
            } else {
                this.reservation.paxNoShow = 0
                this.$toasted.error('Invalid No-Show amount');
            }
        },
        checkAllIn: function() {
            if(this.checkinAllowed){
                // this.reservation.paxCheckedIn = this.reservation.paxTotal
                this.reservation.paxCheckedIn = this.totalPax
                this.reservation.paxNoShow = 0
                this.checkinNoShowChanged()
            }
        },
        noShowAllIn: function() {
            if(this.checkinAllowed){
                this.reservation.paxCheckedIn = 0
                // this.reservation.paxNoShow = this.reservation.paxTotal
                this.reservation.paxNoShow = this.totalPax
                this.checkinNoShowChanged()
            }
        },
        checkinNoShowChanged: function() {
            // disable this function, the checkin/no-show data are now saved only on save reservation
            return false


            this.updateCheckinsNoShows({
                supplierId: this.account.supplierId,
                bookingId: this.reservation.id,
                totalCheckIn: this.reservation.paxCheckedIn,
                totalNoShow: this.reservation.paxNoShow,
            }).then(response => {
                // console.log('response.status ', response.status);
                if(response && response.status == 200){
                    // this.saveReservation()
                }
            })
        },
        changePax: function(operation, personPrice) {
            let quantityAvailable = this.reservation.event.maximumLotation - this.reservation.event.quantityBooked
            console.log('this.reservation m:', this.reservation.event.maximumLotation);
            console.log('this.reservation b:', this.reservation.event.quantityBooked);
            console.log('quantityAvailable:', quantityAvailable);

            let audience = this.audienceTypeIdToObj(personPrice.audienceType)
            // let quantityPerTicket = audience.occupancy? audience.occupancy : 1 // for example: "Group of 3" will have 3, else just use 1
            let quantityPerTicket = personPrice.audienceTypeOccupancy? personPrice.audienceTypeOccupancy : 1

            if(operation == 'add'){
                if(quantityAvailable - quantityPerTicket >= 0 || this.reservation.event.maximumLotation == -1){
                    this.reservation.event.quantityBooked+= Number(quantityPerTicket)
                    personPrice.quantityToBook++
                } else {
                    this.$toasted.info('Event has no more available Pax.')
                }
            } else {
                if(personPrice.quantityToBook > 0){
                    this.reservation.event.quantityBooked--
                    personPrice.quantityToBook--

                    if(personPrice.quantityToBook == 0){
                        personPrice.id = 0
                    }
                }
            }
        },
        showDetailCheckin: function() {
            this.showDetailedCheckin = !this.showDetailedCheckin
        },
        saveReservation: function() {
            this.updateExistingReservation({
                supplierId: this.account.supplierId,
                reservation: this.reservation
            }).then(response => {
                eventHub.$emit('updateReservationsList', this.reservation);
            })
        },
        updateCalculations: function () {
            return this.setReservationCalculations(this.reservation)
        },
        toggleEditPax: function () {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            if(this.editingPax){
                if(this.reservation.paxCheckedIn > this.totalPax){
                    this.reservation.paxCheckedIn = this.totalPax
                }

                if(this.reservation.paxNoShow > this.totalPax){
                    this.reservation.paxNoShow = this.totalPax
                }


                this.updateCalculations(this.reservation).then(r => {
                    // this.saveReservation()
                })
            } else {

            }
            this.editingPax = !this.editingPax
        },
    }
}
</script>

<style lang="scss" scoped>
.checkinsHolder{
    // min-height: 163px;
}

.paxQtdEditor{
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// Checkins.vue?0f698798